/**
 * @module app.bdc.reports.bdcLadditionCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function BdcLadditionCtrl($scope, $window, $rootScope, pricesService, ladditionService) {
        var self = {};

        /* Init */
        self.orderForm = $rootScope.orderForm;

        if (!self.orderForm) {
            return $scope.goTo('/list');
        }

        self.user = $rootScope.user;
        self.order = $rootScope.order;

        pricesService.setOrderForm(self.orderForm);
        pricesService.setOrder(self.order);

        /* Functions */

        /**
         * Get the date of the day
         * @return {String}
         */
        self.getDate = function getDate() {
            return moment().format('DD/MM/YYYY');
        };

        /**
         * Get the translated offer contract type
         * @param  {Object} option
         * @param  {String} contractTypeCode
         * @return {String}
         */
        self.getContractType = function getContractType(option, contractTypeCode) {
            // Specific options rules apply before general contract rules
            if (option.reference === 'TPE') {
                return 'Mensualités 48 mois';
            }

            if (option.reference === 'MAINT' && contractTypeCode === 'ACHAT') {
                return 'Mensualités 48 mois';
            }

            if (option.reference === 'TPECABLE') {
                return 'Tarification Achat';
            }

            // General contract type rules
            if (contractTypeCode === 'ACHAT') {
                return 'Tarification Achat';
            }

            if (contractTypeCode === 'LOC48') {
                return 'Mensualités 48 mois';
            }

            if (contractTypeCode === 'LOC36') {
                return 'Mensualités 36 mois';
            }

            return '&nbsp'; // White space to be rendered properly in the html table
        };

        /**
         * Get and format the installation date
         * @return {String}
         */
        self.getDateInstallation = function getDateInstallation() {
            return self.order.laddition.dateInstallation
                ? moment(self.order.laddition.dateInstallation, 'YYYY-MM-DD').format('MMMM YYYY')
                : null;
        };

        self.getOptionTotalPrice = function getOptionTotalPrice(option) {
            return (
                pricesService.getUnitPrice(option.prices, self.order.laddition.contractType.code).value *
                option.nbOptions
            );
        };

        self.filterOptions = function filterOptions(options, type) {
            return options.filter(function(option) {
                return option.optionType.code === type;
            });
        };

        self.order.laddition.options = ladditionService.getLadditionOptions(self.order.options);

        /* Prices */
        self.totalPrices = ladditionService.calculateLadditionPrice(self.order.laddition);
        /* Options */
        self.standard = self.order.laddition.options.filter(function(option) {
            return option.optionType.code === 'LADDITION_STANDARD' || option.optionType.code === 'LADDITION_LICENCE';
        });
        self.service = self.filterOptions(self.order.laddition.options, 'LADDITION_SERVICE');
        self.hardware = self.order.laddition.options.filter(function(option) {
            return option.optionType.code === 'LADDITION_MATERIEL' || option.optionType.code === 'LADDITION_TPE';
        });
        self.fees = self.filterOptions(self.order.laddition.options, 'LADDITION_FRAIS');

        return self;
    }

    BdcLadditionCtrl.$inject = ['$scope', '$window', '$rootScope', 'pricesService', 'ladditionService'];

    angular.module('app.bdc.reports.bdcLadditionCtrl', []).controller('BdcLadditionCtrl', BdcLadditionCtrl);
});
